<template>
	<v-card v-can="'orderrow.read'">
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$basket"
				start
			/>
			<translate>Policy Details</translate>
		</v-card-title>
		<v-card-text>
			<v-row no-gutters>
				<v-col>
					<span>#{{ orderKey }}</span>
				</v-col>
				<v-col class="d-flex justify-end">
					<v-btn
						size="small"
						variant="outlined"
						@click="policySheetAction"
					>
						<img src="/bo/images/icons/page_white_acrobat.png">
						<translate>Policy sheet</translate>
					</v-btn>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col>
					<v-data-table
						:headers="headers"
						:items="orderrows"
						hide-default-footer
						disable-pagination
						disable-sort
					>
						<template #item.premium="{ item }">
							<span>
								€ {{ item.premium }}
							</span>
						</template>
						<template #item.end="{ item }">
							<span v-if="item.hasCancellation">
								<strong>{{ item.end }}</strong>
								<v-tooltip>
									<template #activator="{ props }">
										<v-icon
											color="yellow"
											v-bind="props"
											icon="$alert"
										/>
									</template>
									{{ getHasCancellationText(item) }}
								</v-tooltip>
							</span>
							<span v-else>
								{{ item.end }}
							</span>
						</template>
						<template #item.actions="{ item }">
							<v-row
								class="align-center"
								no-gutters
							>
								<v-col>
									<v-btn
										v-if="item.canModifyEndDate"
										block
										variant="outlined"
										size="small"
										color="error"
										@click="cancelAction(item.id)"
									>
										<translate>Cancel</translate>
									</v-btn>
								</v-col>
							</v-row>
							<v-row
								class="align-center pt-1"
								no-gutters
							>
								<v-col>
									<v-btn
										v-if="item.isNewClaimAllowed"
										block
										size="small"
										variant="outlined"
										color="primary"
										@click="newClaimAction(item.id)"
									>
										<translate>New claim</translate>
									</v-btn>
								</v-col>
							</v-row>
							<v-row
								class="align-center pt-1"
								no-gutters
							>
								<v-col>
									<update-policy-details :orderrow="item" />
								</v-col>
							</v-row>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>

import {
	axios,
} from '../../services/axios-service.js';

export default {
	name: 'PolicyDetails',

	props: {
		orderId: {
			type: Number,
			required: true,
		},

		orderKey: {
			type: Number,
			required: true,
		},
	},

	data () {
		return {
			orderrows: [],
		};
	},

	computed: {
		headers: function () {
			return [
				{
					title: this.$gettext('Insurance'), value: 'insurance', width: '1%'
				},
				{
					title: this.$gettext('Insured product'), value: 'product', width: '1%'
				},
				{
					title: this.$gettext('IMEI'), value: 'imei', width: '1%'
				},
				{
					title: this.$gettext('Serial Number'), value: 'serialNumber', width: '1%'
				},
				{
					title: this.$gettext('EAN'), value: 'ean', width: '1%'
				},
				{
					title: this.$gettext('Premium'), value: 'premium', width: '1%'
				},
				{
					title: this.$gettext('Status'), value: 'status', width: '1%'
				},
				{
					title: this.$gettext('Start'), value: 'start', width: '1%'
				},
				{
					title: this.$gettext('End'), value: 'end', width: '1%'
				},
				{
					title: this.$gettext('Actions'), value: 'actions', width: '1%'
				},

			];
		},
	},

	mounted () {
		if (localStorage.getItem('permissions').includes('orderrow.read')) {
			this.retrieveOrderrows();
		}
	},

	methods: {

		/**
		 * Retrieves the list of orderrows for the given orders
		 */
		retrieveOrderrows () {
			axios
				.get(`/bo/orders/policydetails?id=${this.orderId}`)
				.then(({
					data: items,
				}) => {
					this.orderrows = items;
				})
				.catch((error) => {
					window.captureException(error);
				});
		},

		/**
		 *
		 * @param {Array} item
		 * @returns {string}
		 */
		getHasCancellationText (item) {
			let text = this.$gettext('End date modified: ');

			if (item.cancelledBy) {
				text = text + item.cancelledBy;
			} else {
				text = text + this.$gettext('Unknown');
			}

			if (item.cancelledAt) {
				text = text + ' ' + this.$gettext('on') + ' ' + item.cancelledAt;
			} else {
				text = text + ' ' + this.$gettext('on') + ' ' + this.$gettext('Unknown');
			}
			return text;
		},

		/**
		 * Redirects to the policy sheet
		 */
		policySheetAction () {
			window.location.href = `/bo/orders/policysheet?orderrow_id=${this.orderrows[this.orderrows.length - 1].id}`;
		},

		/**
		 * Redirects to canceling confirmation
		 *
		 * @param {number} id
		 */
		cancelAction (id) {
			window.location.href = `/bo/orders/cancel?id=${id}`;
		},

		/**
		 * Redirects to a new claim
		 *
		 * @param {number} id
		 */
		newClaimAction (id) {
			window.location.href = `/bo/orders/claimnew?id=${id}`;
		},
	}
};
</script>
<style scoped lang="less">
.v-data-table ::v-deep td{
	font-size: 12px !important;
	padding: 4.0px 4.0px 4.0px 12.0px !important;
}
.v-data-table ::v-deep th.text-start{
	padding: 0.0px 12.0px !important;
}
</style>
